import tpImage from "../images/team/tp-image.jpeg"
import acImage from "../images/team/ac-image.jpeg"
import jpImage from "../images/team/jp-image.jpeg"

export const UsersTeamInfo = {
    user1: {
        name: "Ana Elisa Casas Botero",
        role: "CEO",
        figure: `${acImage}`,
        linkLinkedin: "https://www.linkedin.com/in/ana-elisa-casas-botero-7476467?originalSubdomain=co",
    },
    user2: {
        name: "Tatiana G. Pineda Vasquez",
        role: "Gerente de proyectos, Co-Founder",
        figure: `${tpImage}`,
        linkLinkedin: "https://www.linkedin.com/in/tatiana-pineda-161723b1",
    },
    user3: {
        name: "Juan Pablo Barrera Rúa",
        role: "Ingeniero I+D",
        figure: `${jpImage}`,
        linkLinkedin: "https://www.linkedin.com/in/jpbarrera24/",
    }
} 